const _ = require('lodash');

const getInconsistentResponses = (responses, allItems) => {
  const userResponses = responses.map(item => { return { ...item, id: parseInt(item.item_id), answer: parseInt( item.answer) } });
  const userResponsesIds = _.orderBy(userResponses, ['id'], ['asc']).map(i => i.id);

  const questions = allItems.map(item => { return { ...item, id: parseInt(item.id), 
    item_correlation: item.item_correlation.split()
    .map(o => parseInt(o)).filter(i => userResponsesIds.includes(i)), right_answer: parseInt(item.right_answer) } });

  const inconsistentResponses = new Set();
  for (const question of questions) {
    const userResponse = userResponses
      .filter(item => item.id === question.id)
      .map(i => i.answer)[0]
    if (userResponse !== question.right_answer) {
      inconsistentResponses.add(question.id);
      for (const relatedQuestionId of question.item_correlation) {
        const relatedQuestion = questions.find(q => q.id === relatedQuestionId);
        if (relatedQuestion && userResponses.filter(item => item.id === relatedQuestionId).length
          && userResponses.filter(item => item.id === relatedQuestionId)[0]
            .answer !== relatedQuestion.right_answer) {
          inconsistentResponses.add(relatedQuestionId);
        }
      }
    }
  }
  const inconsistentResponsesArray = Array.from(inconsistentResponses);
  return inconsistentResponsesArray;
};

module.exports = {
  getInconsistentResponses
};